export const NAME = 'login';

// Actions Types pour logger le user
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const FAILURE_LOGIN = 'FAILURE_LOGIN';



// WEBPACK FOOTER //
// ./src/services/authentication/login/constants.js